var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-by-subject-question"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.$t('values.scoreByQuestion'))+"\n    ")]),_c('b-form-select',{attrs:{"options":_vm.subjectsOptions(_vm.values)},on:{"change":function($event){return _vm.triggerChart(_vm.values)}},model:{value:(_vm.subjectOptionSelected),callback:function ($$v) {_vm.subjectOptionSelected=$$v},expression:"subjectOptionSelected"}}),_c('line-chart',{attrs:{"height":120,"chart-data":_vm.datacollection,"plugins":[
            {
                beforeInit: function (chart, args, options) {
                    chart.legend.afterFit = function () {
                        this.height += 20
                    }
                },
            },
        ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }